import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import GrupoDetalle from './GrupoDetalles';
import GrupoEmpresa from './empresa/Empresa';
import GrupoProveedor from './proveedor/GrupoProveedor';
import GrupoContacto from './contactos/GrupoContacto';
import ServicioAsignado from './servicio/ServicioAsignado';
import ProfaseDataGrid from '../../commons/Datagrid';

import { getEntities } from '../empresa.reducer';
import { useAppDispatch, useAppSelector } from '../../store';
import { hasAnyAuthority, BASE_DE_CLIENTES_EDITAR_DATOS_DE_EMPRESAS_REQUIRED_AUTHORITIES } from '../../shared/authorization';
import { Link } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { FaInbox } from '@react-icons/all-files/fa/FaInbox';
import { FaTag } from '@react-icons/all-files/fa/FaTag';
import DateFormat from '../../commons/componentes/DateFormat';
import { EMPRESA_VENCIMIENTO_DATE_PATTERN } from '../../shared/date/date-formats';
import EmpresaVencimientoVencidoIndicators from '../../shared/empresa/EmpresaVencimientoVencidoIndicators';
import {
  appendEmpresaVencimientoFilterParams,
  type EmpresaVencimientoFilterParam,
} from '../../shared/empresa/empresa-vencimiento-resumen';
import LinkCell from '../../commons/LinkCell';
import GrupoCrearModal from './GrupoCrearModal';
import { EMPRESA_ETIQUETA_CONFIG_PATH } from './empresa-etiqueta-config';

interface Empresa {
    id: number;
    razonSocial: string;
}

function EmpresaTable() {

    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const [rows, setRows] = useState<any>([]);
    const [suppressCrearGrupoFor403, setSuppressCrearGrupoFor403] = useState(false);

    const empresaList = useAppSelector(state => state.empresa.entities);
    const loading = useAppSelector(state => state.empresa.loading);
    const totalItems = useAppSelector(state => state.empresa.totalItems);

    const account = useAppSelector(state => state.authentication.account);
    const canEditDatosEmpresas = hasAnyAuthority(
        account.authorities,
        BASE_DE_CLIENTES_EDITAR_DATOS_DE_EMPRESAS_REQUIRED_AUTHORITIES,
    );

    console.log('App loading');

    useEffect(() => {

    }, [])

    useEffect(() => {
        const onSuppress = () => setSuppressCrearGrupoFor403(true);
        const onForbiddenClosed = () => setSuppressCrearGrupoFor403(false);
        window.addEventListener('profase:suppress-grupo-crear-for-403', onSuppress);
        window.addEventListener('profase:forbidden-modal-closed', onForbiddenClosed);
        return () => {
            window.removeEventListener('profase:suppress-grupo-crear-for-403', onSuppress);
            window.removeEventListener('profase:forbidden-modal-closed', onForbiddenClosed);
        };
    }, []);

    useEffect(() => {
        console.log('empresa list', empresaList);
        if (empresaList != null)
            setRows(empresaList.map((e: any) => ({
                ...e,
                empresaId:
                    e.empresaId != null && e.empresaId !== '' ? e.empresaId : null,
                grpAliasEquilibrio:
                    e.grpAliasEquilibrio ?? e.grupoEmpresarial?.grpAliasEquilibrio ?? '',
                grpAliasDecomsa:
                    e.grpAliasDecomsa ?? e.grupoEmpresarial?.grpAliasDecomsa ?? '',
                vencimientoFiel: e.vencimientoFiel ?? e.vfiel ?? null,
                vencimientoSellos: e.vencimientoSellos ?? e.vsellos ?? null,
                'acciones': e.empresaId ?? e.id
            })));
    }, [empresaList])


    const filters = [
        {
            label: 'Equilibrio',
            name: 'grupo',
        },
        {
            label: 'Decomsa',
            name: 'grupo',
        },
        {
            label: 'RFC',
            name: 'rfc'
        },
        {
            label: 'Empresa',
            name: 'razonSocial'
        },
        {
            label: 'Estatus',
            name: 'estatus',
            type: 'select',
            single: true,
            options: [
                { value: '0', label: 'Inactivo' },
                { value: '1', label: 'Activo' },
                { value: '2', label: 'Incubado' },
            ],
        },
        {
            label: 'Activo',
            name: 'grupo.activo'
        },
        {
            label: 'Venc. Sellos',
            name: 'vencimientoSellosEstado',
            type: 'select',
            single: true,
            options: [
                { value: 'EN_VIGENCIA', label: 'En Vigencia' },
                { value: 'PROXIMO_A_VENCER', label: 'Próximo a vencer' },
                { value: 'SIN_VENCIMIENTO', label: 'Sin vencimiento' },
                { value: 'VENCIDO', label: 'Vencido' },
            ],
        },
        {
            label: 'Venc. Fiel',
            name: 'vencimientoFielEstado',
            type: 'select',
            single: true,
            options: [
                { value: 'EN_VIGENCIA', label: 'En Vigencia' },
                { value: 'PROXIMO_A_VENCER', label: 'Próximo a vencer' },
                { value: 'SIN_VENCIMIENTO', label: 'Sin vencimiento' },
                { value: 'VENCIDO', label: 'Vencido' },
            ],
        },
    ]

    const seleccionarEmpresa = (params: any) => {
        const row = params.row;
        const gid = row.grupoEmpresarial?.id;
        if (gid == null) return;
        const eid = row.empresaId;
        if (eid == null || eid === '') {
            navigate(`/empresas/grupo/${gid}`);
            return;
        }
        navigate(`/empresas/grupo/${gid}/empresa/${eid}`);
    }

    const renderVencimientoDateCell = (params: any) => (
        <DateFormat
            value={params.value}
            pattern={EMPRESA_VENCIMIENTO_DATE_PATTERN}
            highlightIfBeforeToday
        />
    );

    const renderEstatusCell = (params: any) => {
        const raw = params.row.estatus;
        if (raw == null || raw === '') {
            const label = params.row.estatusT;
            if (label != null && String(label).trim() !== '') {
                return <span>{String(label)}</span>;
            }
            return <span style={{ color: '#94a3b8' }}>—</span>;
        }
        const estatus = Number(raw);
        if (estatus === 0) {
            return <span style={{ color: '#ef4444', fontWeight: 600 }}>Inactivo</span>;
        }
        if (estatus === 1) {
            return <span style={{ color: '#22c55e', fontWeight: 600 }}>Activo</span>;
        }
        if (estatus === 2) {
            return <span style={{ color: '#f59e0b', fontWeight: 600 }}>Incubado</span>;
        }
        const label = params.row.estatusT;
        if (label != null && String(label).trim() !== '') {
            return <span>{String(label)}</span>;
        }
        return <span style={{ color: '#94a3b8' }}>—</span>;
    };

    const renderGrupoFilterCell = (params: any) => (
        <LinkCell
            label={params.value == null || params.value === '' ? null : String(params.value)}
            filterName="grupo"
            filterValue={params.value == null || params.value === '' ? null : String(params.value)}
        />
    );

    const renderButtonsCell = (params: any) => {
        return <>
            <button className="btn btn-primary" onClick={() => { seleccionarEmpresa(params); }}>Seleccionar</button>
        </>
    };
    const renderEmpresaCell = (params: any) => {
        const displayText =
            params.value == null || params.value === ''
                ? '-'
                : String(params.value);
        return <>
            <Link
                component="button"
                variant="body2"
                onClick={() => { seleccionarEmpresa(params) }}
            >
                {displayText}
            </Link>
        </>
    };
    const renderMensajesCell = (params: any) => {
        const eid = params.row.empresaId;
        const rfc = params.row.rfc;
        const nombre = String(params.row.razonSocial ?? '').trim() || String(rfc ?? '').trim();
        if ((eid == null || eid === '') && (rfc == null || String(rfc).trim() === '')) {
            return <span style={{ color: '#94a3b8' }}>—</span>;
        }
        return (
            <LinkCell
                label="Buzón Tributario"
                icon={<FaInbox style={{ fontSize: 12, flexShrink: 0 }} />}
                onClick={() => {
                    const p = new URLSearchParams();
                    if (eid != null && eid !== '') p.set('empresaId', String(eid));
                    else p.set('rfc', String(rfc).trim());
                    if (nombre) p.set('empresa', nombre);
                    navigate(`/buzon-tributario?${p.toString()}`);
                }}
            />
        );
    };

    const cols = [
        { field: 'grpAliasEquilibrio', headerName: 'Equilibrio', flex: 1.5, renderCell: renderGrupoFilterCell },
        { field: 'grpAliasDecomsa', headerName: 'Decomsa', flex: 1.5, renderCell: renderGrupoFilterCell },
        { field: 'razonSocial', headerName: 'Razón Social', flex: 3, width: 200, renderCell: renderEmpresaCell },
        { field: 'rfc', headerName: 'RFC', flex: 1.5, renderCell: renderEmpresaCell },
        {
            field: 'mensajes',
            headerName: 'Buzón Tributario',
            flex: 1.6,
            minWidth: 160,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    <FaInbox style={{ fontSize: 12, flexShrink: 0 }} />
                    Buzón Tributario
                </span>
            ),
            renderCell: renderMensajesCell,
        },
        { field: 'vencimientoFiel', headerName: 'Venc. Fiel', flex: 1.2, filterable: false, renderCell: renderVencimientoDateCell },
        { field: 'vencimientoSellos', headerName: 'Venc. Sellos', flex: 1.2, filterable: false, renderCell: renderVencimientoDateCell },
        { field: 'estatus', headerName: 'Estatus', flex: 0.8, sortable: false, renderCell: renderEstatusCell },
        { field: '', headerName: '', flex: 1.2, renderCell: renderButtonsCell },
    ];

    const mapSortToApi = (sort: string): string => {
        const commaIdx = sort.indexOf(',');
        const field = commaIdx >= 0 ? sort.slice(0, commaIdx) : sort;
        const order = commaIdx >= 0 ? sort.slice(commaIdx + 1) : 'asc';
        const apiField =
            field === 'grpAliasEquilibrio' ? 'aliasEquilibrio'
                : field === 'grpAliasDecomsa' ? 'aliasDecomsa'
                    : field.replace(/^grupoEmpresarial\.alias$/, 'alias');
        return `${apiField},${order}`;
    };

    const fetchData = async (params: any) => {
        console.log('fetch', params);
        const sortApi =
            typeof params.sort === 'string'
                ? mapSortToApi(params.sort)
                : params.sort;
        dispatch(getEntities({ ...params, sort: sortApi, listPath: 'grupos' as const }));
    };

    const crearGrupoOpen = location.pathname === '/empresas/grupo/new';

    useEffect(() => {
        if (crearGrupoOpen && !canEditDatosEmpresas) {
            navigate('/empresas', { replace: true });
        }
    }, [crearGrupoOpen, canEditDatosEmpresas, navigate]);

    useEffect(() => {
        if (!crearGrupoOpen) setSuppressCrearGrupoFor403(false);
    }, [crearGrupoOpen]);

    const cerrarCrearGrupo = () => {
        navigate('/empresas');
    };

    const handleVencimientoIndicadorFilter = (
        param: EmpresaVencimientoFilterParam,
        indicador: string,
    ) => {
        const next = appendEmpresaVencimientoFilterParams(searchParams, param, indicador);
        if (next) setSearchParams(next);
    };

    return (

        <div className="p-3">
            <div style={toolbarStyle}>
                <EmpresaVencimientoVencidoIndicators onIndicadorClick={handleVencimientoIndicadorFilter} />
                <div style={toolbarActionsStyle}>
                    <button
                        type="button"
                        className="btn btn-primary d-inline-flex align-items-center gap-2"
                        style={{ flexShrink: 0, alignSelf: 'flex-start' }}
                        disabled={!canEditDatosEmpresas}
                        title={!canEditDatosEmpresas ? 'No tiene permiso para crear grupos' : undefined}
                        onClick={() => navigate('/empresas/grupo/new')}
                    >
                        <FaPlus /> Crear Grupo
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                        style={{ flexShrink: 0, alignSelf: 'flex-start' }}
                        onClick={() => navigate(EMPRESA_ETIQUETA_CONFIG_PATH)}
                    >
                        <FaTag /> Etiquetas
                    </button>
                </div>
            </div>
            <ProfaseDataGrid
                cols={cols}
                title={'Empresas'}
                filters={filters}
                fetch={fetchData}
                rowCount={totalItems}
                loading={loading}
                defaultSortField="razonSocial"
                getRowId={(row: any) => String(row.empresaId ?? row.id)}

                rows={rows}
            ></ProfaseDataGrid>

            <GrupoCrearModal
                open={crearGrupoOpen && canEditDatosEmpresas}
                forceHidden={suppressCrearGrupoFor403}
                onClose={cerrarCrearGrupo}
                onCreated={(id) => navigate(`/empresas/grupo/${id}`)}
            />
        </div >
    );
}

export default EmpresaTable;

const toolbarStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 12,
};

const toolbarActionsStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
};
